import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

type JobResult = { message?: string; error?: string; [key: string]: unknown };

export function useGrowthJobs() {
  const [snapshotLoading, setSnapshotLoading] = useState(false);
  const [snapshotResult, setSnapshotResult] = useState<JobResult | null>(null);
  const [auditsLoading, setAuditsLoading] = useState(false);
  const [auditsResult, setAuditsResult] = useState<JobResult | null>(null);
  const [briefLoading, setBriefLoading] = useState(false);
  const [briefResult, setBriefResult] = useState<JobResult | null>(null);
  const qc = useQueryClient();

  const runSnapshot = async (mode?: 'our' | 'peer' | 'all') => {
    setSnapshotLoading(true);
    setSnapshotResult(null);
    try {
      const { data, error } = await supabase.functions.invoke('growth-snapshot', {
        body: mode ? { mode } : {},
      });
      const result = (data as JobResult) || {};
      if (error) setSnapshotResult({ error: error.message });
      else setSnapshotResult(result);
      qc.invalidateQueries({ queryKey: ['growth'] });
    } finally {
      setSnapshotLoading(false);
    }
  };

  const runAudits = async () => {
    setAuditsLoading(true);
    setAuditsResult(null);
    try {
      const { data, error } = await supabase.functions.invoke('growth-run-audits', { body: {} });
      const result = (data as JobResult) || {};
      if (error) setAuditsResult({ error: error.message });
      else setAuditsResult(result);
      qc.invalidateQueries({ queryKey: ['growth'] });
    } finally {
      setAuditsLoading(false);
    }
  };

  const runBrief = async () => {
    setBriefLoading(true);
    setBriefResult(null);
    try {
      const { data, error } = await supabase.functions.invoke('growth-weekly-brief', { body: {} });
      const result = (data as JobResult) || {};
      if (error) setBriefResult({ error: error.message });
      else setBriefResult(result);
      qc.invalidateQueries({ queryKey: ['growth'] });
    } finally {
      setBriefLoading(false);
    }
  };

  return {
    runSnapshot,
    runAudits,
    runBrief,
    snapshotLoading,
    snapshotResult,
    auditsLoading,
    auditsResult,
    briefLoading,
    briefResult,
  };
}
